import { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import Loading from "react-loading";
import { useDispatch } from "react-redux";

import { updateGlobalConfigurationsAction } from "store/modules/globalConfiguration/actions";
import { useAppSelector } from "store/rootReducer";

import GeneralInput from "components/GeneralInput";
import SearchEmpty from "components/SearchEmpty";

import { SystemConfigurationService } from "services/systemConfiguration";

import { ContainerLoading } from "./styles";

export interface IServiceIntegrationNotificationItem {
  hearingTypeId: number;
  hearingTypeName: string;
  active: boolean;
  attendantRoleList: Array<IDefaultObject>;
}

export interface IDefaultObject {
  ServiceIntegrationNotificationId?: number;
  id: number;
  name: string;
  active: boolean;
  attendantRoleId: number;
  hearingTypeId: number;
}

export interface IServiceIntegrationNotificationResponseAPI {
  customerId: number;
  hearingType: Array<IDefaultObject>;
  attendantRole: Array<IDefaultObject>;
  ServiceIntegrationNotification: Array<IServiceIntegrationNotificationItem>;
}

export const ServiceIntegrationNotification = ({
  inputValues,
  setInputValues,
  notify,
  hearingId,
}: any) => {
  const [filterList, setFilterList] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const { userCustomerProfile } = useAppSelector((state) => state.profile);
  const dispatch = useDispatch();
  const { user } = useAppSelector((state) => state.user);

  const getAllConfigurationsByCustomerId = async () => {
    setLoading(true);
    const { data } = await SystemConfigurationService.getAllByCustomer(
      user?.customerId,
    );

    dispatch(updateGlobalConfigurationsAction(data));

    const list = data?.filter(
      (item: any) => item?.name === "IntegrationNotify",
    );
    setFilterList(list);

    const initialValues: { [key: string]: string } = {};
    list.forEach((item: any) => {
      try {
        const value = JSON.parse(item.value);
        value.parametros.forEach((param: any) => {
          const inputId = `${item?.name}-${param?.name}`;
          if (param.name === "placeid") {
            initialValues[inputId] = userCustomerProfile.placeId;
          } else if (param.name === "customerid") {
            initialValues[inputId] = user?.customerId;
          } else if (param.name === "hearingid") {
            initialValues[inputId] = hearingId;
          } else {
            initialValues[inputId] = "";
          }
        });
      } catch {
        // skip items with invalid JSON
      }
    });
    setInputValues(initialValues);
    setLoading(false);
  };

  useEffect(() => {
    getAllConfigurationsByCustomerId();
  }, []);

  return (
    <>
      {loading ? (
        <ContainerLoading>
          <Loading width={40} type="spin" color="#000" />
        </ContainerLoading>
      ) : notify ? (
        <Grid container spacing={3}>
          {filterList?.map((item: any, index: any) => {
            let value;
            try {
              value = JSON.parse(item.value);
            } catch {
              return null;
            }
            return (
              <Grid item xs={12} key={index}>
                {value.parametros.map((param: any, paramIndex: any) => {
                  const inputId = `${item?.name}-${param?.name}`;
                  const autoFilledValue =
                    param.name === "placeid"
                      ? userCustomerProfile.placeId
                      : param.name === "customerid"
                        ? user?.customerId
                        : param.name === "hearingid"
                          ? hearingId
                          : null;
                  const isAutoFilled = autoFilledValue != null;

                  return (
                    <Grid item xs={12} key={paramIndex}>
                      <GeneralInput
                        id={inputId}
                        error={false}
                        value={isAutoFilled ? autoFilledValue : (inputValues[inputId] || "")}
                        required
                        onChange={(e) =>
                          setInputValues((prevValues: any) => ({
                            ...prevValues,
                            [inputId]: e,
                          }))
                        }
                        name={param?.name}
                        label={param.label}
                        disabled={isAutoFilled}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <SearchEmpty textMessage={"Sem permissão"} typeIcon={"avatar"} />
      )}
    </>
  );
};
